import { SingleSelectField, useDynamicConfig } from "@dgs/core";
import { FC } from "react";

interface Props {
	label: string;
	name: string;
	required?: boolean;
	onChange?: () => void;
}

export const LanguageSingleSelectField: FC<Props> = ({ label, name, required, onChange }) => {
	const { languageSettings } = useDynamicConfig();

	return (
		<SingleSelectField
			label={label}
			name={name}
			getLabel={(locale) => locale}
			clearable={false}
			options={languageSettings.availableLanguages}
			required={required}
			onChange={onChange}
		/>
	);
};
